/** 하단 슬라이드 네비: 타이틀 제외 이 개수까지 버튼을 펼쳐 보이고, 초과 시 가로 스크롤 */
export const SLIDE_FOOTER_NAV_MAX_VISIBLE_PAGE_TABS = 15;

const DOT_GAP_PX = 8;
const TITLE_TAB_WIDTH_PX = 56;
const NUMBER_TAB_WIDTH_PX = 42;
const REGISTRY_TAB_WIDTH_PX = 58;
const COMMUNICATION_TAB_WIDTH_PX = 72;
/** 스크롤 영역 양끝 그라데이션과 버튼 사이 inset (CSS padding-inline과 동일) */
export const SLIDE_FOOTER_DOTS_SCROLL_INSET_PX = 20;

export function isSlideFooterDotsScrollable(pageTabCount: number): boolean {
  return pageTabCount >= SLIDE_FOOTER_NAV_MAX_VISIBLE_PAGE_TABS;
}

export function footerSlideTabKey(pageIndex: number | null | 'communication'): string {
  if (pageIndex === 'communication') return 'communication';
  return pageIndex == null ? 'title' : `page-${pageIndex}`;
}

export function scrollFooterSlideTabIntoView(
  scrollRoot: HTMLElement | null,
  tabKey: string
): void {
  if (!scrollRoot?.classList.contains('is-scrollable')) return;
  const tab = scrollRoot.querySelector<HTMLElement>(`[data-footer-slide-tab="${tabKey}"]`);
  if (!tab) return;
  tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
}

export function slideFooterDotsScrollMaxWidthPx(
  pageTabCount: number,
  hasTitleTab: boolean,
  isRegistry: boolean,
  hasCommunicationTab = false
): number {
  const visibleTabs = Math.min(pageTabCount, SLIDE_FOOTER_NAV_MAX_VISIBLE_PAGE_TABS);
  const tabWidth = isRegistry ? REGISTRY_TAB_WIDTH_PX : NUMBER_TAB_WIDTH_PX;
  const itemCount = visibleTabs + (hasTitleTab ? 1 : 0) + (hasCommunicationTab ? 1 : 0);
  const gapCount = Math.max(0, itemCount - 1);
  return (
    (hasTitleTab ? TITLE_TAB_WIDTH_PX : 0) +
    visibleTabs * tabWidth +
    (hasCommunicationTab ? COMMUNICATION_TAB_WIDTH_PX : 0) +
    gapCount * DOT_GAP_PX +
    SLIDE_FOOTER_DOTS_SCROLL_INSET_PX * 2
  );
}

export function slideFooterDotsScrollStyle(
  pageTabCount: number,
  hasTitleTab: boolean,
  isRegistry = false,
  hasCommunicationTab = false
): Record<string, string> | undefined {
  if (!isSlideFooterDotsScrollable(pageTabCount)) return undefined;
  return {
    ['--cp-slide-dots-scroll-max' as string]: `${slideFooterDotsScrollMaxWidthPx(
      pageTabCount,
      hasTitleTab,
      isRegistry,
      hasCommunicationTab
    )}px`,
  };
}
